import Cookies from 'js-cookie'

const COOKIE_SPA_TESTING_BAR = 'SPA_TESTING_BAR'
const COOKIE_SPA_NUXT_URL = 'SPA_NUXT_KC_URL'

export const isTestingBar = () => {
  return Cookies.get(COOKIE_SPA_TESTING_BAR) === '1'
}

export const isReviewApp = () => {
  return Cookies.get(COOKIE_SPA_NUXT_URL)
}
